var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipesClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#213A68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8342 28.2931C31.2538 26.86 32.7114 25.4595 34.2304 24.1241C35.1342 22.7655 39.7008 20.7322 38.4799 19.1642C37.6896 17.88 36.8047 15.9724 35.3188 15.5024C31.9069 18.2383 28.7221 21.2161 25.6983 24.3428C18.9124 18.0755 13.4041 14.0833 18.5385 21.1138C20.6727 22.4119 22.665 23.9054 24.5578 25.52C21.3778 28.8979 18.3776 32.448 15.5005 36.0865C15.5005 37.7337 17.081 39.3156 18.1836 40.5067C19.1963 41.6234 20.1285 38.9062 20.9472 38.3292C23.4363 35.263 26.0106 32.2526 28.7458 29.4004C32.735 33.3553 36.4308 37.6546 40.4106 41.4978C41.2671 40.3904 35.7683 34.1463 29.8342 28.2931Z",
    fill: "#F5FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipesClose);
export default __webpack_public_path__ + "static/media/RecipesClose.37fae59b7bf7969f1f4905fe7c7367fc.svg";
export { ForwardRef as ReactComponent };